export default __webpack_public_path__ + "static/media/shopping-basket-2.cce2aba2.png";